<template>
    <div class='userAgreetment'>
        <div class='userAgreetmentBox' v-html='agreements'></div>
    </div>
</template>

<script>
import { Switch ,Indicator } from 'mint-ui';
import router from '@/router'
// import 'mint-ui/lib/style.css';
export default {
  name: 'UserAgreetment',
  data () {
    return {
       agreements:'',
    }
  },
  created (){
    var self = this;
    Indicator.open();
    //获得用户信息
    this.$api.agreements({
        type:3
    })
    .then(
    res => {
        console.log(res.data);
        self.agreements=res.data.content;
        Indicator.close();
    });
  },
  methods:{
    toPage(pageName,pJson){
      var self=this;
      self.$router.push({ name:pageName,query:pJson});
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .userAgreetmentBox{
        width:100vw;
        text-align: justify;
        padding:.5rem .3rem;
    }
    /* .userAgreetmentBox p{
        width:100%;
        font-size: 0.28rem;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #222222;
    }
    .userAgreetmentBox span{
        width:100%;
        font-size: 0.26rem;
        text-align: justify;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #444444;
        line-height: 0.42rem;
    } */
</style>

<style scoped  lang="scss">

.userAgreetment{
    width:100vw;
}
</style>



// WEBPACK FOOTER //
// src/components/UserAgreement/index.vue